import { defaultState } from './state';

export default {
	autogenerateWooCreds({ dispatch }) {
		return dispatch('saveWooCreds', { auto: true });
	},
	saveWooCreds({ commit }, { key, secret, auto = false }) {
		commit('loading', 'wooconnect', { root: true });
		return new Promise((resolve, reject) => {
			this._vm.$api
				.post({ wpEndpoint: `omapp/v1/woocommerce/${auto ? 'autogenerate' : 'save'}` })
				.send({ key, secret })
				.then(({ body }) => {
					commit('doneLoading', 'wooconnect', { root: true });

					commit('fetched', 'wooKey', { root: true });
					commit('setWooConnected', Boolean(body.id));
					commit('setWooKey', body);

					this._vm.$bus.$emit('wooKeyFetched', body);

					resolve();
				})
				.catch((error) => {
					commit('closeAlerts', null, { root: true });

					commit('setWooConnected', false);
					error.explanation = `<strong>Something went wrong while attempting to ${
						auto ? 'autogenerate' : 'save'
					} the WooCommerce Keys.</strong>`;
					if (this._vm.$env.isDevelopment()) {
						error.explanation +=
							'<p>This is likely because you are in the <code>DEVELOPMENT</code> environment, and cookies could not be passed to the auto-generation request.</p>';
					}
					error.closes = true;
					commit('setError', error, { root: true });
					commit('doneLoading', 'wooconnect', { root: true });

					reject(error);
					// eslint-disable-next-line no-console
					console.error({ error });
				});
		});
	},
	disconnectWoo({ commit }) {
		commit('loading', 'wooconnect', { root: true });
		return new Promise((resolve, reject) => {
			return this._vm.$api
				.post({ wpEndpoint: 'omapp/v1/woocommerce/disconnect' })
				.then(() => {
					commit('setWooConnected', false);
					commit('setWooKey', defaultState().wooKey);
					commit('doneLoading', 'wooconnect', { root: true });

					this._vm.$bus.$emit('wooKeyRemoved');

					resolve();
				})
				.catch((error) => {
					commit('closeAlerts', null, { root: true });

					error.explanation =
						'<strong>Something went wrong while attempting to disconnect WooCommerce.</strong>';
					error.closes = true;
					commit('setError', error, { root: true });
					commit('doneLoading', 'wooconnect', { root: true });
					reject(error);
					// eslint-disable-next-line no-console
					console.error({ error });
				});
		});
	},
	fetchWooKey({ getters, commit, rootGetters }, force = false) {
		if (!getters.isWooConnected) {
			return;
		}

		return new Promise((resolve, reject) => {
			if (!force && (rootGetters.isFetched('wooKey') || rootGetters.isFetching('wooKey'))) {
				return resolve();
			}

			commit('fetching', 'wooKey', { root: true });

			return this._vm.$api
				.get({ wpEndpoint: 'omapp/v1/woocommerce/key' })
				.then(({ body }) => {
					commit('fetched', 'wooKey', { root: true });
					commit('setWooConnected', Boolean(body.id));
					commit('setWooKey', body);
					this._vm.$bus.$emit('wooKeyFetched', body);
					resolve();
				})
				.catch((error) => {
					error.explanation =
						'<strong>Something went wrong while attempting to disconnect WooCommerce.</strong>';
					reject(error);
					// eslint-disable-next-line no-console
					console.error({ error });
				});
		});
	},
};
